var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('menuDrawer'),_c('v-col',[_c('v-sheet',{attrs:{"min-height":"70vh","min-width":"90%","rounded":"lg"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }